import React from "react";
import { PersonnelsCard } from "./PersonnelsCard";
import { PersonnelsUIProvider } from "./PersonnelsUIContext";

export function PersonnelsPage({ history }) {
  const personnelsUIEvents = {
    openNewPersonnelPage: () => {
      history.push("/personeller/ekle");
    },
    openEditPersonnelPage: (id) => {
      history.push(`/personeller/duzenle/${id}`);
    },
  };
  
  return (
    <PersonnelsUIProvider personnelsUIEvents={personnelsUIEvents}>
      <PersonnelsCard />
    </PersonnelsUIProvider>
 );
}